import React, { useEffect, useMemo, useState } from "react";
import { Col, Container, Modal, Row } from "react-bootstrap";
import { MdNavigateBefore, MdNavigateNext } from "react-icons/md";
import { RiCloseLine } from "react-icons/ri";
import "./styles.scss";
import {
  ApplicationStatus,
  Country,
  TeamRole
} from "../../../../../../shared/constants/Constant";
import OutlineButton
  from "../../../../../../shared/components/ui/outline-button/OutlineButton";
import { BsQuestion } from "react-icons/bs";
import { GoCheck } from "react-icons/go";
import { AiOutlineUsergroupAdd } from "react-icons/ai";
import { GrFormClose } from "react-icons/gr";
// import BarLoader from "react-spinners/BarLoader";
import Moment from "react-moment";
import PreviewSriLanka
  from "../../../../../application/components/preview/srilanka/Preview";
import PreviewIndia
  from "../../../../../application/components/preview/india/Preview";
import PreviewMalaysia
  from "../../../../../application/components/preview/malaysia/Preview";
import PreviewJamaica
  from "../../../../../application/components/preview/jamaica/Preview";
import PreviewBosnia
  from "../../../../../application/components/preview/bosnia/Preview";
import IconButton
  from "../../../../../../shared/components/ui/icon-button/IconButton";
import TeamMemberJamaica
  from "../../../../../../database/models/application-form/jamaica/TeamMember";
import TeamMemberSriLanka
  from "../../../../../../database/models/application-form/srilanka/TeamMember";
import TeamMemberMalaysia
  from "../../../../../../database/models/application-form/malaysia/TeamMember";
import PdfDownloadLink from "./components/PdfDownloadLink";
import {
  ApplicationWithId
} from "../../../../../../contexts/applications-context/ApplicationsContext";

interface IProps {
  application: ApplicationWithId;
  applications: ApplicationWithId[];
  onHide(): void;
  show: boolean;
  onAccept?(application: ApplicationWithId): void;
  onReject?(application: ApplicationWithId): void;
  onShowRemarks?(application: ApplicationWithId): void;
  onCreateProfiles?(application: ApplicationWithId): void;
  loading?: boolean;
}

const ApplicationPreview = (props: IProps) => {
  const [index, setIndex] = useState(0);
  const [currentApplication, setCurrentApplication] = useState(
    props.application
  );

  useEffect(() => {
    if (index !== -1) setCurrentApplication(props.applications[index]);
  }, [index, props.applications]);

  useEffect(() => {
    setCurrentApplication(props.application);
  }, [props.application]);

  useEffect(() => {
    const index: number = props.applications.findIndex(
      (application) => application.id === props.application.id
    );
    setIndex(index);
  }, [props.applications, props.application, props.show]);

  const getSDG = () => {
    if (currentApplication.sdg) {
      try {
        return currentApplication.sdg.map((s, index) => (
          <span key={index}>
            {s}
            {currentApplication.sdg &&
            index !== currentApplication.sdg.length - 1 &&
            currentApplication.sdg?.length > 1
              ? ", "
              : ""}
          </span>
        ));
      } catch (e) {
        return <>{currentApplication.sdg}</>;
      }
    }
  };

  const rejectButton = (): any => {
    return (
      <>
        <span className="d-md-none">
          <IconButton color="red" size="sm">
            <RiCloseLine />
          </IconButton>
        </span>
        <span className="action-button d-none d-md-block">
          <OutlineButton
            color="red"
            icon={<RiCloseLine />}
            onClick={() => {
              props.onReject && props.onReject(currentApplication);
            }}
          >
            Reject
          </OutlineButton>
        </span>
      </>
    );
  };
  const acceptButton = (): any => {
    return (
      <>
        <span className="action-button">
          <OutlineButton
            color="green"
            icon={<GoCheck />}
            onClick={() => {
              props.onAccept && props.onAccept(currentApplication);
            }}
          >
            Accept
          </OutlineButton>
        </span>
      </>
    );
  };
  const showRemarksButton = (): any => {
    return (
      <span className="action-button">
        <OutlineButton
          color="yellow"
          icon={<BsQuestion />}
          onClick={() => {
            props.onShowRemarks && props.onShowRemarks(currentApplication);
          }}
        >
          View Remark
        </OutlineButton>
      </span>
    );
  };
  const createProfileButton = (): any => {
    return (
      <span className="action-button">
        <OutlineButton
          color="light-blue"
          icon={<AiOutlineUsergroupAdd />}
          onClick={() => {
            props.onCreateProfiles &&
              props.onCreateProfiles(currentApplication);
          }}
        >
          Create Profiles
        </OutlineButton>
      </span>
    );
  };

  const setApplicationStatusColor = () => {
    switch (
      currentApplication.teamGenerated ||
      currentApplication.acceptanceState
    ) {
      case currentApplication.teamGenerated:
        return (
          <>
            <hr
              style={{
                backgroundColor: "#008ae6",
                height: 7,
                borderColor: "#008ae6",
              }}
            />
          </>
        );
      case ApplicationStatus.ACCEPTED:
        return (
          <>
            <hr
              style={{
                backgroundColor: "#00cc00",
                height: 7,
                borderColor: "#00cc00",
                width: "100%",
              }}
            />
          </>
        );
      case ApplicationStatus.PENDING:
        return (
          <>
            <hr
              style={{
                backgroundColor: "#737373",
                height: 7,
                borderColor: "#737373",
              }}
            />
          </>
        );
      default:
        return (
          <>
            <hr
              style={{
                backgroundColor: "#e60000",
                height: 7,
                borderColor: "#e60000",
              }}
            />
          </>
        );
    }
  };

  const getActionButtons = (): any => {
    switch (currentApplication.acceptanceState) {
      case ApplicationStatus.ACCEPTED:
        return (
          <>
            {rejectButton()}
            {createProfileButton()}
          </>
        );
      case ApplicationStatus.REJECTED:
        return (
          <>
            {showRemarksButton()}
            {acceptButton()}
          </>
        );
      default:
        return (
          <>
            {acceptButton()} {rejectButton()}
          </>
        );
    }
  };

  const pdfNode = useMemo(() => {
    const previewSriLanka = () => (
      <PreviewSriLanka
        data={{
          application: {
            country: Country.SRI_LANKA,
            importance: currentApplication.importance || "",
            industries: currentApplication.industries || [],
            members:
              currentApplication.members?.map((member) => {
                const m: TeamMemberSriLanka = {
                  country: member.country,
                  email: member.email,
                  fullName: member.fullName,
                  role: member.role,
                  university: member.university,
                  contact: member.contact || "",
                  resideProvince: member.resideProvince || "",
                };
                return m;
              }) || [],
            pitchLink: currentApplication.pitchLink || "",
            projectName: currentApplication.projectName || "",
            inslId: currentApplication.inslId || "",
            projectProgress: currentApplication.projectProgress || "",
            proposalLink: currentApplication.proposalLink || "",
            solvingApproach: currentApplication.solvingApproach || "",
            solvingProblem: currentApplication.solvingProblem || "",
            stage: currentApplication.stage || "Business Plan Formulation",
            teamName: currentApplication.teamName || "",
          },
          fileName: "view",
        }}
      />
    );

    const previewIndia = () => (
      <PreviewIndia
        data={{
          application: {
            projectName: currentApplication.projectName || "",
            problem: currentApplication.problem || "",
            unique: currentApplication.unique || "",
            stage: currentApplication.stage || "",
            progress: currentApplication.progress || "",
            pitch: currentApplication.pitch || "",
            requiredInvensment: currentApplication.requiredInvensment || "",
            invesmentDone: currentApplication.invesmentDone || "",
            expectedTime: currentApplication.expectedTime || "",
            anyPatent: currentApplication.anyPatent || "",
            whyEntreprenur: currentApplication.whyEntreprenur || "",
            howLoongThinking: currentApplication.howLoongThinking || "",
            strenghts: currentApplication.strenghts || "",
            anyCourse: currentApplication.anyCourse || "",
            howStrong: currentApplication.howStrong || 1,
            admireEntreprenur: currentApplication.admireEntreprenur || "",
            primaryExpectation: currentApplication.primaryExpectation || "",
            additionalEffort: currentApplication.additionalEffort as boolean,
            attendAllWorkshops: currentApplication.attendAllWorkshops as boolean,
            payRequiredEnrolmentFee: currentApplication.payRequiredEnrolmentFee as boolean,
            teamName: currentApplication.teamName || "",
            domain: currentApplication.domain || "",
            college: currentApplication.college || "",
            mentorName: currentApplication.mentorName || "",
            mentorEmail: currentApplication.mentorEmail || "",
            mentorContact: currentApplication.mentorContact || "",
            members: currentApplication.members as any,
            country: Country.INDIA,
          },
          fileName: "view",
        }}
      />
    );
    const previewMalaysia = () => (
      <PreviewMalaysia
        data={{
          application: {
            country: Country.MALAYSIA,
            importance: currentApplication.importance || "",
            industries: currentApplication.industries || [],
            sdg: currentApplication.sdg,
            members:
              currentApplication.members?.map((member) => {
                const m: TeamMemberMalaysia = {
                  country: member.country,
                  email: member.email,
                  fullName: member.fullName,
                  phone: member.phone,
                  role: member.role,
                  university: member.university,
                  state: member.state || "",
                };
                return m;
              }) || [],
            projectName: currentApplication.projectName || "",
            projectProgress: currentApplication.projectProgress || "",
            proposalLink: currentApplication.proposalLink || "",
            solvingApproach: currentApplication.solvingApproach || "",
            solvingProblem: currentApplication.solvingProblem || "",
            stage: currentApplication.stage || "Business Plan Formulation",
            teamName: currentApplication.teamName || "",
          },
          fileName: "view",
        }}
      />
    );

    const previewBosnia = () => (
      <PreviewBosnia
        data={{
          application: {
            commitment: currentApplication.members
              ? currentApplication.members[0].commitment || ""
              : "",
            contact: currentApplication.members
              ? currentApplication.members[0].contact || ""
              : "",
            country: Country.BOSNIA,
            cvLink: currentApplication.members
              ? currentApplication.members[0].cvLink || ""
              : "",
            dob: currentApplication.members
              ? new Date(currentApplication.members[0].dob || "")
              : new Date(),
            email: currentApplication.members
              ? currentApplication.members[0].email
              : "",
            fullName: currentApplication.members
              ? currentApplication.members[0].fullName
              : "",
            motivation: currentApplication.members
              ? currentApplication.members[0].motivation || ""
              : "",
            pastExperience: currentApplication.members
              ? currentApplication.members[0].pastExperience || ""
              : "",
            placeOfResidence: currentApplication.members
              ? currentApplication.members[0].residence || ""
              : "",
            whatYouAreStudying: currentApplication.members
              ? currentApplication.members[0].studying || ""
              : "",
            whoYouAre: currentApplication.members
              ? currentApplication.members[0].status || ""
              : "",
          },
          fileName: "view",
        }}
      />
    );

    const previewJamaica = () => (
      <PreviewJamaica
        data={{
          application: {
            country: Country.JAMAICA,
            importance: currentApplication.importance || "",
            industries: currentApplication.industries || [],
            projectTheme: currentApplication.projectTheme || [],
            members:
              currentApplication.members?.map((member) => {
                const m: TeamMemberJamaica = {
                  contactNumber: member.contactNumber || "",
                  country: member.country,
                  email: member.email,
                  fullName: member.fullName,
                  role: member.role,
                  university: member.university,
                };
                return m;
              }) || [],
            projectName: currentApplication.projectName || "",
            projectProgress: currentApplication.projectProgress || "",
            proposalLink: currentApplication.proposalLink || "",
            solvingApproach: currentApplication.solvingApproach || "",
            solvingProblem: currentApplication.solvingProblem || "",
            stage: currentApplication.stage || "Business Plan Formulation",
            teamName: currentApplication.teamName || "",
          },
          fileName: "view",
        }}
      />
    );

    const getPDFDocument = () => {
      switch (currentApplication.country) {
        case Country.SRI_LANKA:
          return previewSriLanka();
        case Country.MALAYSIA:
          return previewMalaysia();
        case Country.BOSNIA:
          return previewBosnia();
        case Country.INDIA:
          return previewIndia();
        default:
          return previewJamaica();
      }
    };
    return props.show &&
      currentApplication &&
      JSON.stringify(currentApplication) !== "{}" ? (
      <PdfDownloadLink
        document={getPDFDocument()}
        fileName={`application-${currentApplication.teamName}`}
      />
    ) : (
      <></>
    );
  }, [currentApplication, props.show]);

  return (
    <div>
      <Modal
        show={props.show}
        onHide={props.onHide}
        size="xl"
        className="model-preview-application"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        {currentApplication && (
          <Modal.Body className="content-wrapper">
            <Col lg={12}>{setApplicationStatusColor()}</Col>
            <Container className="h-100">
              <Row className="h-100">
                <Col xs={1} className="h-100 p-0">
                  <Container fluid className="h-100">
                    <Row className="h-100">
                      <Col xs={12} className="p-0" style={{ height: "45%" }}>
                        {/* <GrFormClose
                        className="btn-close"
                        onClick={props.onHide}
                      /> */}
                      </Col>
                      <Col xs={12} className="p-0" style={{ height: "55%" }}>
                        {index > 0 && (
                          <div className="action-icon">
                            <MdNavigateBefore
                              onClick={() => {
                                if (index > 0) {
                                  setIndex((ps) => ps - 1);
                                }
                              }}
                            />
                          </div>
                        )}
                      </Col>
                    </Row>
                  </Container>
                </Col>
                <Col xs={10} className="p-0 h-100">
                  <Container className="h-100">
                    <Row
                      style={{ height: "10%" }}
                      className="action-button-wrapper"
                    >
                      <Col xs={12}>
                        <div className="h-100 d-flex align-items-center justify-content-center">
                          {props.show &&
                            !currentApplication.teamGenerated &&
                            getActionButtons()}
                        </div>
                      </Col>

                      {props.show && pdfNode}
                    </Row>
                    <Row style={{ height: "83%" }}>
                      <Col xs={12} className="content small-scroll">
                        {currentApplication.country === Country.INDIA ? (
                          <Container fluid>
                            <Row>
                              <Col xs={12} className="mt-3">
                                <p>
                                  <strong>Project/Product Name:</strong> <br />
                                  {currentApplication.projectName}
                                </p>
                              </Col>
                              <Col xs={12} className="mt-3">
                                <p>
                                  <strong>
                                    Problem Statement (or what are you trying to
                                    achieve?):
                                  </strong>{" "}
                                  <br />
                                  {currentApplication.problem}
                                </p>
                              </Col>
                              <Col xs={12} className="mt-3">
                                <p>
                                  <strong>
                                    What is unique about your Project/Product:
                                  </strong>{" "}
                                  <br />
                                  {currentApplication.unique}
                                </p>
                              </Col>
                              <Col xs={12} className="mt-3">
                                <p>
                                  <strong>What stage you are at:</strong> <br />
                                  <br />
                                  {currentApplication.stage}
                                </p>
                              </Col>
                              <Col xs={12} className="mt-3">
                                <p>
                                  <strong>What is the progress so far?</strong>{" "}
                                  <br />
                                  {currentApplication.progress}
                                </p>
                              </Col>
                              <Col xs={12} className="mt-3">
                                <p style={{ textAlign: "left" }}>
                                  <strong>Pitch document:</strong> <br />
                                  <a
                                    href={currentApplication.pitch}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    download pitch
                                  </a>
                                </p>
                              </Col>
                              <Col xs={12} className="mt-3">
                                <p>
                                  <strong>
                                    How much investment is required to create a
                                    first prototype that meets your objectives?
                                  </strong>{" "}
                                  <br />
                                  {currentApplication.requiredInvensment}
                                </p>
                              </Col>
                              <Col xs={12} className="mt-3">
                                <p>
                                  <strong>
                                    How much investment is done by your team so
                                    far, if any?
                                  </strong>{" "}
                                  <br />
                                  {currentApplication.invesmentDone}
                                </p>
                              </Col>
                              <Col xs={12} className="mt-3">
                                <p>
                                  <strong>
                                    Expected time needed to implement a
                                    prototype:
                                  </strong>{" "}
                                  <br />
                                  {currentApplication.expectedTime}
                                </p>
                              </Col>
                              <Col xs={12} className="mt-3">
                                <p>
                                  <strong>
                                    Any Patent applied or will be applied
                                  </strong>{" "}
                                  <br />
                                  {currentApplication.anyPatent}
                                </p>
                              </Col>
                              <Col xs={12} className="mt-3">
                                <p>
                                  <strong>
                                    Why do you want to be an entrepreneur?
                                    Please write not more than 200 words, for
                                    each team member.
                                  </strong>{" "}
                                  <br />
                                  {currentApplication.whyEntreprenur}
                                </p>
                              </Col>
                              <Col xs={12} className="mt-3">
                                <p>
                                  <strong>
                                    How long have you been thinking of the idea
                                    you are proposing?
                                  </strong>{" "}
                                  <br />
                                  {currentApplication.howLoongThinking}
                                </p>
                              </Col>
                              <Col xs={12} className="mt-3">
                                <p>
                                  <strong>
                                    What strengths does your team have that will
                                    help you in this journey?
                                  </strong>{" "}
                                  <br />
                                  {currentApplication.strenghts}
                                </p>
                              </Col>
                              <Col xs={12} className="mt-3">
                                <p>
                                  <strong>
                                    Any course on entrepreneurship, business
                                    management that any team member has already
                                    taken?
                                  </strong>{" "}
                                  <br />
                                  {currentApplication.anyCourse}
                                </p>
                              </Col>
                              <Col xs={12} className="mt-3">
                                <p>
                                  <strong>
                                    How strong is your belief in your idea?
                                  </strong>{" "}
                                  <br />
                                  {currentApplication.howStrong}
                                </p>
                              </Col>
                              <Col xs={12} className="mt-3">
                                <p>
                                  <strong>
                                    Which entrepreneur do you admire the most?
                                    Why
                                  </strong>{" "}
                                  <br />
                                  {currentApplication.admireEntreprenur}
                                </p>
                              </Col>
                              <Col xs={12} className="mt-3">
                                <p>
                                  <strong>
                                    What is your primary expectation of the
                                    program
                                  </strong>{" "}
                                  <br />
                                  {currentApplication.primaryExpectation}
                                </p>
                              </Col>
                              <Col xs={12} className="mt-3">
                                <p>
                                  <strong>
                                    I understand that this will be an additional
                                    effort beyond my regular academics
                                  </strong>{" "}
                                  <br />
                                  {currentApplication.additionalEffort
                                    ? "Yes"
                                    : "No"}
                                </p>
                              </Col>
                              <Col xs={12} className="mt-3">
                                <p>
                                  <strong>
                                    I commit to completing the full program and
                                    attend all workshops/activities/courses
                                  </strong>{" "}
                                  <br />
                                  {currentApplication.attendAllWorkshops
                                    ? "Yes"
                                    : "No"}
                                </p>
                              </Col>
                              <Col xs={12} className="mt-3">
                                <p>
                                  <strong>
                                    I confirm that I will pay the required
                                    enrolment fee if selected (Rs 1000 / Rs 750
                                    if a IEEE member in team/ Rs 500 if a TEMS
                                    member in team)
                                  </strong>{" "}
                                  <br />
                                  {currentApplication.payRequiredEnrolmentFee
                                    ? "Yes"
                                    : "No"}
                                </p>
                              </Col>
                              <Col xs={12} className="mt-1">
                                <p>
                                  <strong>Team Name</strong> <br />
                                  {currentApplication.teamName}
                                </p>
                              </Col>
                              <Col xs={12} className="mt-1">
                                <p>
                                  <strong>Domain/Category</strong> <br />
                                  {currentApplication.domain}
                                </p>
                              </Col>
                              <Col xs={12} className="mt-1">
                                <p>
                                  <strong>College/University name</strong>{" "}
                                  <br />
                                  {currentApplication.college}
                                </p>
                              </Col>
                              <Col xs={12} className="mt-1">
                                <p>
                                  <strong>Faculty mentor Name</strong> <br />
                                  {currentApplication.mentorName}
                                </p>
                              </Col>
                              <Col xs={12} className="mt-1">
                                <p>
                                  <strong>Faculty Mentor Email Id</strong>{" "}
                                  <br />
                                  {currentApplication.mentorEmail}
                                </p>
                              </Col>
                              <Col xs={12} className="mt-1">
                                <p>
                                  <strong>Faculty Mentor Contact No</strong>{" "}
                                  <br />
                                  {currentApplication.mentorContact}
                                </p>
                              </Col>

                              <Col xs={12} className="mt-1">
                                <table className="w-100">
                                  <thead>
                                    <tr>
                                      <th>Name</th>
                                      <th>Year/semester</th>
                                      <th>Email</th>
                                      <th>Contact Number</th>
                                      <th>Role</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {currentApplication.members
                                      ?.filter(
                                        (member) =>
                                          member.role === TeamRole.LEADER
                                      )
                                      .map((member, index) => (
                                        <tr key={index}>
                                          <td style={{ verticalAlign: "top" }}>
                                            {member.fullName}
                                          </td>
                                          <td style={{ verticalAlign: "top" }}>
                                            {member.yearOfStudy}
                                          </td>
                                          <td style={{ verticalAlign: "top" }}>
                                            {member.email}
                                          </td>
                                          <td style={{ verticalAlign: "top" }}>
                                            {member.contact}
                                          </td>
                                          <td style={{ verticalAlign: "top" }}>
                                            {member.role}
                                          </td>
                                        </tr>
                                      ))}
                                    {props.application.members
                                      ?.filter(
                                        (member) =>
                                          member.role === TeamRole.MEMBER
                                      )
                                      .map((member, index) => (
                                        <tr key={index}>
                                          <td style={{ verticalAlign: "top" }}>
                                            {member.fullName}
                                          </td>
                                          <td style={{ verticalAlign: "top" }}>
                                            {member.yearOfStudy}
                                          </td>
                                          <td style={{ verticalAlign: "top" }}>
                                            {member.email}
                                          </td>
                                          <td style={{ verticalAlign: "top" }}>
                                            {member.contact}
                                          </td>
                                          <td style={{ verticalAlign: "top" }}>
                                            {member.role}
                                          </td>
                                        </tr>
                                      ))}
                                  </tbody>
                                </table>
                              </Col>
                            </Row>
                          </Container>
                        ) : (
                          <Container fluid>
                            {currentApplication.country !== Country.BOSNIA ? (
                              <Row>
                                <Col xs={12} className="mt-3">
                                  <p>
                                    <strong>Team/Company Name:</strong>{" "}
                                    {currentApplication.teamName}
                                  </p>
                                </Col>
                                {currentApplication.country ===
                                  Country.MALAYSIA &&
                                  currentApplication.sdg && (
                                    <Col xs={12} className="mt-3">
                                      <p>
                                        <strong>
                                          Which Sustainable Development
                                          Goals(SDG) theme are you considering?
                                        </strong>{" "}
                                        {getSDG()}
                                      </p>
                                    </Col>
                                  )}
                                {currentApplication.country ===
                                  Country.SRI_LANKA && (
                                  <Col xs={12} className="mt-3">
                                    <p>
                                      <strong>INSL ID No:</strong>{" "}
                                      {currentApplication.inslId}
                                    </p>
                                  </Col>
                                )}
                                <Col xs={12} className="mt-3">
                                  <p>
                                    <strong>Product/Project Name:</strong>{" "}
                                    {currentApplication.projectName}
                                  </p>
                                </Col>
                                {currentApplication.country ===
                                  Country.JAMAICA && (
                                  <Col xs={12} className="mt-3">
                                    <p>
                                      <strong>
                                        What THEME does your product/project
                                        fall under?
                                      </strong>{" "}
                                    </p>
                                    {currentApplication.projectTheme?.map(
                                      (theme, index) => (
                                        <p key={index} className="mb-1">
                                          {theme}
                                        </p>
                                      )
                                    )}
                                  </Col>
                                )}
                                {currentApplication?.industries &&
                                  currentApplication.industries[0] !==
                                    "devValue" && (
                                    <Col xs={12} className="mt-3">
                                      <p className="mb-1">
                                        <strong>
                                          What industry does your
                                          product/project fall under?
                                        </strong>{" "}
                                      </p>
                                      {currentApplication.industries?.map(
                                        (industry, index) => (
                                          <p key={index} className="mb-1">
                                            {industry}
                                          </p>
                                        )
                                      )}
                                    </Col>
                                  )}
                                {currentApplication.solvingProblem !==
                                  "devValue" && (
                                  <Col xs={12} className="mt-3">
                                    <p>
                                      <strong>
                                        What is the problem you are solving?
                                      </strong>{" "}
                                    </p>
                                    <p>{currentApplication.solvingProblem}</p>
                                  </Col>
                                )}
                                {currentApplication.solvingApproach !==
                                  "devValue" && (
                                  <Col xs={12} className="mt-3">
                                    <p>
                                      <strong>
                                        How are you solving the problem?
                                      </strong>{" "}
                                    </p>
                                    <p>{currentApplication.solvingApproach}</p>
                                  </Col>
                                )}
                                {currentApplication.importance !==
                                  "devValue" && (
                                  <Col xs={12} className="mt-3">
                                    <p>
                                      <strong>
                                        Why is This important to you?
                                      </strong>{" "}
                                    </p>
                                    <p>{currentApplication.importance}</p>
                                  </Col>
                                )}
                                <Col xs={12} className="mt-3">
                                  <p>
                                    <strong>What stage are you at?</strong>{" "}
                                  </p>
                                  <p>{currentApplication.stage}</p>
                                </Col>
                                {currentApplication.projectProgress !==
                                  "devValue" && (
                                  <Col xs={12} className="mt-3">
                                    <p>
                                      <strong>
                                        What is the progress you have made so
                                        far?
                                      </strong>{" "}
                                    </p>
                                    <p>{currentApplication.projectProgress}</p>
                                  </Col>
                                )}
                                {currentApplication.country ===
                                  Country.SRI_LANKA &&
                                  currentApplication.pitchLink !== "" && (
                                    <Col xs={12} className="mt-3">
                                      <p>
                                        <strong>Pitch link</strong>{" "}
                                        <a
                                          target="_blank"
                                          rel="noopener noreferrer"
                                          href={currentApplication.pitchLink}
                                        >
                                          {currentApplication.pitchLink}
                                        </a>
                                      </p>
                                    </Col>
                                  )}
                                <Col xs={12} className="mt-3">
                                  <p>
                                    <strong>Project Proposal:</strong>{" "}
                                    <a
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      href={currentApplication.proposalLink}
                                    >
                                      download proposal
                                    </a>
                                  </p>
                                </Col>
                                <Col xs={12} className="mt-3">
                                  <p
                                    className="mb-1"
                                    style={{
                                      fontSize: "18px",
                                      textDecoration: "underline",
                                    }}
                                  >
                                    <strong>Personal Info</strong>{" "}
                                  </p>
                                </Col>
                                <Col xs={12} className="mt-1">
                                  <table className="w-100">
                                    <thead>
                                      <tr>
                                        <th>Full Name</th>
                                        <th>Email Address</th>
                                        <th>Name of University/Institute</th>
                                        {currentApplication.country ===
                                        Country.MALAYSIA && currentApplication.sdg === undefined ? (
                                          <th>State</th>
                                        ) : (
                                          <th>Contact Number</th>
                                        )}
                                        <th>Role</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {currentApplication.members
                                        ?.filter(
                                          (member) =>
                                            member.role === TeamRole.LEADER
                                        )
                                        .map((member, index) => (
                                          <tr key={index}>
                                            <td
                                              style={{ verticalAlign: "top" }}
                                            >
                                              {member.fullName}
                                            </td>
                                            <td
                                              style={{ verticalAlign: "top" }}
                                            >
                                              {member.email}
                                            </td>
                                            <td
                                              style={{ verticalAlign: "top" }}
                                            >
                                              {member.university}
                                            </td>
                                            {currentApplication.country ===
                                            Country.MALAYSIA && member.phone === undefined ? (
                                              <td
                                                style={{ verticalAlign: "top" }}
                                              >
                                                {member.state}
                                              </td>
                                            ) : (
                                              <td
                                                style={{ verticalAlign: "top" }}
                                              >
                                                {currentApplication.country ===
                                                Country.JAMAICA
                                                  ? member.contactNumber
                                                  : currentApplication.country === Country.MALAYSIA
                                                    ? member.phone
                                                    : member.contact}
                                              </td>
                                            )}
                                            <td
                                              style={{ verticalAlign: "top" }}
                                            >
                                              {member.role}
                                            </td>
                                          </tr>
                                        ))}
                                      {props.application.members
                                        ?.filter(
                                          (member) =>
                                            member.role === TeamRole.MEMBER
                                        )
                                        .map((member, index) => (
                                          <tr key={index}>
                                            <td
                                              style={{ verticalAlign: "top" }}
                                            >
                                              {member.fullName}
                                            </td>
                                            <td
                                              style={{ verticalAlign: "top" }}
                                            >
                                              {member.email}
                                            </td>
                                            <td
                                              style={{ verticalAlign: "top" }}
                                            >
                                              {member.university}
                                            </td>
                                            {currentApplication.country ===
                                            Country.MALAYSIA && member.phone === undefined ? (
                                              <td
                                                style={{ verticalAlign: "top" }}
                                              >
                                                {member.state}
                                              </td>
                                            ) : (
                                              <td
                                                style={{ verticalAlign: "top" }}
                                              >
                                                {currentApplication.country ===
                                                Country.JAMAICA
                                                  ? member.contactNumber
                                                  : currentApplication.country === Country.MALAYSIA
                                                  ? member.phone
                                                  : member.contact}
                                              </td>
                                            )}
                                            <td
                                              style={{ verticalAlign: "top" }}
                                            >
                                              {member.role}
                                            </td>
                                          </tr>
                                        ))}
                                    </tbody>
                                  </table>
                                </Col>
                              </Row>
                            ) : (
                              currentApplication?.members?.map(
                                (member: any, index) => (
                                  <Row key={index}>
                                    <Col xs={12} className="mt-3">
                                      <p
                                        className="mb-1"
                                        style={{
                                          fontSize: "18px",
                                          textDecoration: "underline",
                                        }}
                                      >
                                        <strong>Personal Information</strong>{" "}
                                      </p>
                                    </Col>
                                    <Col xs={12} className="mt-1">
                                      <p>
                                        <strong>Full Name:</strong>{" "}
                                        {member.fullName}
                                      </p>
                                    </Col>
                                    <Col xs={12} className="mt-3">
                                      <p>
                                        <strong>Date of birth:</strong>{" "}
                                        <Moment format="MM/DD/YYYY">
                                          {member.dob}
                                        </Moment>
                                      </p>
                                    </Col>
                                    <Col xs={12} className="mt-3">
                                      <p>
                                        <strong>Email Address:</strong>{" "}
                                        {member.email}
                                      </p>
                                    </Col>
                                    <Col xs={12} className="mt-3">
                                      <p>
                                        <strong>Phone number:</strong>{" "}
                                        {member.contact}
                                      </p>
                                    </Col>
                                    <Col xs={12} className="mt-3">
                                      <p>
                                        <strong>
                                          Current place of residence (example:
                                          Tuzla, Banja Luka, Sarajevo etc)
                                        </strong>{" "}
                                      </p>
                                      <p>{member.residence}</p>
                                    </Col>
                                    <Col xs={12} className="mt-3">
                                      <p>
                                        <strong>Who are you?</strong>{" "}
                                      </p>
                                      <p>{member.status}</p>
                                    </Col>
                                    <Col xs={12} className="mt-3">
                                      <p>
                                        <strong>
                                          What are you studying and/or where are
                                          you employed? (If student - please
                                          list what you are studying currently
                                          ex. computer science, marketing), If
                                          you work in a company please list it)
                                        </strong>{" "}
                                      </p>
                                      <p>{member.studying}</p>
                                    </Col>
                                    <Col xs={12} className="mt-3">
                                      <p>
                                        <strong>CV/Resume:</strong>{" "}
                                        <a
                                          target="_blank"
                                          rel="noopener noreferrer"
                                          href={member.cvLink}
                                        >
                                          Download CV/Resume
                                        </a>
                                      </p>
                                    </Col>
                                    <Col xs={12} className="mt-3">
                                      <p
                                        className="mb-1"
                                        style={{
                                          fontSize: "18px",
                                          textDecoration: "underline",
                                        }}
                                      >
                                        <strong>Key selection criteria</strong>{" "}
                                      </p>
                                    </Col>
                                    <Col xs={12} className="mt-1">
                                      <p>
                                        <strong>
                                          Motivation - What is your motivation
                                          to want to participate in the program
                                          and what do you hope to achieve?
                                        </strong>{" "}
                                      </p>
                                      <p>{member.motivation}</p>
                                    </Col>
                                    <Col xs={12} className="mt-3">
                                      <p>
                                        <strong>
                                          Commitment - This program will require
                                          you to invest at least 10 hours per
                                          week in it. What makes you believe you
                                          are committed to completing the
                                          program?
                                        </strong>{" "}
                                      </p>
                                      <p>{member.commitment}</p>
                                    </Col>
                                    <Col xs={12} className="mt-3">
                                      <p>
                                        <strong>
                                          Past experience - What past
                                          experiences do you have that make you
                                          a good candidate for a scholarship in
                                          this program?
                                        </strong>{" "}
                                      </p>
                                      <p> {member.pastExperience}</p>
                                    </Col>
                                  </Row>
                                )
                              )
                            )}
                          </Container>
                        )}
                      </Col>
                    </Row>
                  </Container>
                </Col>

                <Col xs={1} className="h-100 p-0">
                  <Container fluid className="h-100">
                    <Row className="h-100 p-0">
                      <Col
                        xs={12}
                        className="p-0 d-flex justify-content-center"
                        style={{ height: "45%" }}
                      >
                        <GrFormClose
                          className="btn-close"
                          style={{ marginTop: "20px", fontSize: "30px" }}
                          onClick={props.onHide}
                        />
                      </Col>
                      <Col xs={12} className="p-0" style={{ height: "55%" }}>
                        {index < props.applications.length - 1 && (
                          <div className="action-icon">
                            <MdNavigateNext
                              onClick={() => {
                                if (index < props.applications.length - 1) {
                                  setIndex((ps) => ps + 1);
                                }
                              }}
                            />
                          </div>
                        )}
                      </Col>
                    </Row>
                  </Container>
                </Col>
              </Row>
            </Container>
          </Modal.Body>
        )}
      </Modal>
    </div>
  );
};

export default ApplicationPreview;
